module.exports = __webpack_public_path__ + "media/assets/svg/logos/whatsapp-889650e13428b4626986d2b120f5cd86.svg";